import { NgModule, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {
  transform(array: any): any {
    return (array || []).sort((a: any, b: any) => {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
  }
}

@NgModule({
  imports: [],
  declarations: [SortPipe],
  exports: [SortPipe]
})
export class SortPipeModule { }
